import * as React from "react";
import { useMemo, useState } from "react";
import { useFormikContext } from "formik";
import { Spinner } from "components/common";
import { RowContainer, ColContainer } from "components/lookup-tables/layout-componets";
import useScopePermissions from "hooks/useScopePermissions";
import { useFetchCache, useFetchAllCaches } from "components/lookup-tables/hooks/useLookupTablesAPI";
import CachePicker from "components/lookup-tables/cache-form/CachePicker";
import CacheFormView from "components/lookup-tables/cache-form/CacheFormView";
import CacheShow from "components/lookup-tables/cache-view/cache-show";
function CacheFormStep() {
  const { values, setFieldValue } = useFormikContext();
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(values);
  const { allCaches, loadingAllCaches } = useFetchAllCaches();
  const { cache, loadingCache } = useFetchCache(values.cache_id);
  const [showForm, setShowForm] = useState(false);
  const showCache = useMemo(() => !!cache, [cache]);
  const canModify = useMemo(
    () => !values.id || !loadingScopePermissions && (scopePermissions == null ? void 0 : scopePermissions.is_mutable),
    [values.id, loadingScopePermissions, scopePermissions == null ? void 0 : scopePermissions.is_mutable]
  );
  const onSaved = (newCache) => {
    setFieldValue("cache_id", newCache.id);
    setShowForm(false);
  };
  const onCancel = () => {
    setFieldValue("cache_id", "");
    setShowForm(false);
  };
  const onCreateClick = () => {
    onCancel();
    setTimeout(() => setShowForm(true), 100);
  };
  return /* @__PURE__ */ React.createElement(ColContainer, { $gap: "lg", $align: "center" }, loadingAllCaches ? /* @__PURE__ */ React.createElement(RowContainer, null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading caches..." })) : /* @__PURE__ */ React.createElement(React.Fragment, null, canModify && !showForm && /* @__PURE__ */ React.createElement(RowContainer, null, /* @__PURE__ */ React.createElement(CachePicker, { onCreateClick, caches: allCaches })), showCache && !loadingCache && /* @__PURE__ */ React.createElement(CacheShow, { cache }), showForm && !showCache && /* @__PURE__ */ React.createElement(CacheFormView, { onCancel, saved: onSaved, isStep: true })));
}
export default CacheFormStep;
